// extracted by mini-css-extract-plugin
export var header = "_xe-1";
export var maskBottom = "_xe-6";
export var maskMiddle = "_xe-7";
export var maskTop = "_xe-5";
export var root = "_xe-0";
export var scrollDownButton = "_xe-3";
export var scrollDownButtonHidden = "_xe-4";
export var viewport = "_xe-2";